
<template>
  <!--门禁设备详情-->
  <div class="advanced-form">
    <a-form :form="form">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of deviceInfoList" :key="index" v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" :label="item.label">
                <span v-if="item.key === 'online'" class="ant-form-text">{{item.value === '1' ? '在线' : '离线'}}</span>
                <span v-else class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

    <div class="card">
      <div class="card-head">
        <h3>运行参数</h3>
      </div>
      <div class="card-body">
        <a-row type="flex" :gutter="24">
          <a-col v-for="(item, index) of functionList" :key="index" v-bind="$store.state.advanced_colWidth">
            <a-form-item class="dev-param-select" v-if="item.inputType==='select'" :label="item.label">
              <a-select
                v-decorator="item.props"
                :disabled="item.disabled"
                allowClear
                showSearch
                :filterOption="filterOption"
                :placeholder="item.placeholder">
                <a-select-option
                  v-for="(el, order) of item.options"
                  :key="order"
                  :value="el.value">
                  {{el.label}}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item v-if="item.inputType==='input'" :label="item.label" :extra="item.extra">
              <a-input style="width: 60%" v-decorator="item.props" :placeholder="item.placeholder" :disabled="item.disabled"/>
            </a-form-item>

            <a-form-item v-if="item.inputType==='inputNumber'" :label="item.label" :extra="item.extra">
              <a-input-number v-decorator="item.props" :placeholder="item.placeholder" :min="item.min" :max="item.max" :disabled="item.disabled"/>
            </a-form-item>

            <a-form-item v-if="item.inputType==='switch'" :label="item.label">
              <a-switch v-decorator="item.props" checkedChildren="开" unCheckedChildren="关" :disabled="item.disabled"/>
            </a-form-item>
          </a-col>
        </a-row>
      </div>
    </div>
    </a-form>
  </div>
</template>

<script>
import { inputSearch } from 'ant-design-vue-admin-x';
export default {
  mixins: [inputSearch],
  name: 'smartDoorDetail',
  data () {
    return {
      deviceInfoList: [
        {key: 'communityName', label: '小区', value: ''},
        {key: 'positionName', label: '位置', value: ''},
        {key: 'deviceName', label: '设备名称', value: ''},
        {key: 'factoryName', label: '设备厂家', value: ''},
        {key: 'productType', label: '产品型号', value: ''},
        {key: 'deviceSncode', label: '设备编码', value: ''},
        {key: 'createTime', label: '添加时间', value: ''},
        {key: 'activeTime', label: '激活时间', value: ''},
        {key: 'lastOnlineTime', label: '最后在线时间', value: ''},
        {key: 'online', label: '当前状态', value: ''},
        {key: 'version', label: '软件版本', value: ''},
        {key: 'mac', label: '蓝牙MAC', value: ''},
        {key: 'netMac', label: '以太网MAC', value: ''}
      ],
      functionList: []
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  mounted () {
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/device/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.loopSetVal(this.deviceInfoList, data, item);
        }

        let inputType = { enum: 'select', bool: 'switch', int: 'inputNumber', float: 'inputNumber', string: 'input' };
        let valueObj = {};
        let list = [];
        data.actionList.forEach((el, index) => {
          let label = el.settingName;
          let type = el.settingType;
          let propId = el.settingId;
          let obj = {
            label: label,
            inputType: inputType[type],
            options: [],
            placeholder: '',
            props: [`${propId}`]
          };
          valueObj[`${propId}`] = el.settingVal;
          let valContent = JSON.parse(el.settingValContent);
          if (type === 'enum') {
            let option = [];
            valContent.forEach((part) => {
              Object.keys(part).forEach(item => {
                option.push({ label: part[item], value: item });
              });
            });
            obj.options = option;
            obj.placeholder = `请选择${label}`;
            obj.disabled = true;
            obj.props[1] = {rules: []};
          }

          if (type === 'int' || type === 'float') {
            let extra = this.generateExtra(valContent, el.settingUnique);
            obj.options = [];
            obj.placeholder = `${label}`;
            obj.min = parseFloat(valContent.min);
            obj.max = parseFloat(valContent.max);
            obj.disabled = true;
            obj.extra = extra;
            obj.props[1] = {
              validateTrigger: 'blur',
              rules: []
            };
          }

          if (type === 'bool') {
            let settingVal = el.settingVal;
            if (settingVal) {
              let arr = [];
              for (let item in valContent) {
                if (settingVal === valContent[item]) {
                  if (item === 'open') {
                    valueObj[`${propId}`] = true;
                  } else {
                    valueObj[`${propId}`] = false;
                  }
                }
                arr.push(valContent[item]);
              }
              if (arr.indexOf(settingVal) < 0) {
                valueObj[`${propId}`] = false;
              }
            } else {
              valueObj[`${propId}`] = false;
            }
            obj.options = [];
            obj.placeholder = '';
            obj.disabled = true;
            obj.props[1] = {
              valuePropName: 'checked',
              rules: []
            };
          }

          if (type === 'string') {
            let len = parseFloat(valContent);
            obj.options = [];
            obj.placeholder = `请输入${label}`;
            obj.disabled = true;
            obj.extra = `值长度: 0-${len}`;
            obj.props[1] = {};
          }
          list.push(obj);
        });
        valueObj = {...valueObj, door_eq_name: data.deviceName};
        this.functionList = list;
        this.$nextTick(() => {
          this.form.setFieldsValue(valueObj);
        });
      });
    },
    loopSetVal (target, data, item) {
      target.forEach((el) => {
        if (el.key === item) {
          el.value = data[item];
        }
      });
    }
  }
};
</script>
